export function getOrigin() {
  const params = new URLSearchParams(window.location.search)

  return params.get('origin')
}
